import {
    SalesTransactionType,
    SalesTransactionUidPrefix,
    SalesTransactionInvoiceStatus,
    SalesTransactionOrderStatus,
    SalesTransactionOrderStatusGroup,
    SalesTransactionOrderLineStatus,
    SalesTransactionCreditMemoStatus,
} from '~/types';
import type {
    SalesTransactionTypeObj,
    SalesTransactionStatus,
    SalesTransaction
} from '~/types';


export function useSalesTransactionHelpers() {

    function getTypeObjFromUid(uid: Nilish<string>): Nullable<SalesTransactionTypeObj> {
        if (!uid) {
            return null
        }

        const prefix = uid.split('_')?.[0] ?? null;

        switch (prefix) {
            case SalesTransactionUidPrefix.ORDER:
            case 'pso':
                return getTypeObjFromType(SalesTransactionType.ORDER);
            case SalesTransactionUidPrefix.INVOICE:
            case 'psi':
                return getTypeObjFromType(SalesTransactionType.INVOICE);
            case SalesTransactionUidPrefix.CREDIT_MEMO:
            case 'pcm':
                return getTypeObjFromType(SalesTransactionType.CREDIT_MEMO);
        }

        return null;
    }

    function getTypeObjFromType(type: SalesTransactionType): Nullable<SalesTransactionTypeObj> {
        switch (type) {
            case SalesTransactionType.ORDER:
                return {
                    type: SalesTransactionType.ORDER,
                    title: 'Order',
                    titlePlural: 'Orders',
                    itemDetailPath: '/order',
                    permissionProp: 'orders'
                };
            case SalesTransactionType.INVOICE:
                return {
                    type: SalesTransactionType.INVOICE,
                    title: 'Invoice',
                    titlePlural: 'Invoices',
                    itemDetailPath: '/invoice',
                    permissionProp: 'invoices'
                };
            case SalesTransactionType.CREDIT_MEMO:
                return {
                    type: SalesTransactionType.CREDIT_MEMO,
                    title: 'Credit Memo',
                    titlePlural: 'Credit Memos',
                    itemDetailPath: '/credit-memo',
                    permissionProp: 'credit_memos'
                };
            default:
                return null;
        }
    }

    function getTypeFromRoute(path: string): Nullable<SalesTransactionType> {
        switch (true) {
            case path.startsWith('/order'):
                return SalesTransactionType.ORDER;
            case path.startsWith('/invoice'):
                return SalesTransactionType.INVOICE;
            case path.startsWith('/credit-memo'):
                return SalesTransactionType.CREDIT_MEMO;
            default:
                return null;
        }
    }

    function getStatusEnumFromType(type: SalesTransactionType | string): Nullable<SalesTransactionStatus> {
        switch (type) {
            case SalesTransactionType.ORDER:
                return SalesTransactionOrderStatusGroup;
            case SalesTransactionType.INVOICE:
                return SalesTransactionInvoiceStatus;
            case SalesTransactionType.CREDIT_MEMO:
                return SalesTransactionCreditMemoStatus;
            case 'order_line':
                return SalesTransactionOrderLineStatus;
            default:
                return null;
        }
    }

    function canPayNow(item: SalesTransaction): boolean {
        return item.balance > 0 && item.customerStatus !== SalesTransactionOrderStatus.DRAFT;
    }

    return {
        getTypeObjFromUid,
        getTypeObjFromType,
        getTypeFromRoute,
        getStatusEnumFromType,
        canPayNow
    };
}
